<template>
    <div class="session__list_grid">
        <div class="container">
            <div class="columns columns--custom is-4 is-multiline">
                <template v-for="(session, index) in items">
                    <div
                        class="column column--custom is-4-widescreen is-6-desktop is-6-tablet is-12-mobile"
                        :key="index">
                        <session-list-grid-item
                            :session="session"
                        />
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import SessionListGridItem from '@/components/ebs/sessions/list/SessionListGridItem'

export default {
  components: { SessionListGridItem },
  name: 'session-list-grid',
  props: {
    items: {
      type: [Array, Object]
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/sessions/sessionlistgrid";
</style>
